module.exports = __webpack_public_path__ + "img/Board_1.e564cd21.png";